import './assets/css/style.css';
import './assets/css/responsive.css';
import './assets/css/bootsnav.css'
import React from 'react';
import Home from "./components/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import JobDetail from './components/JobDetail';
import CategoryJobs from './components/CategoryJobs';
import BrowseCategory from './components/BrowseCategory';
import BrowseJobs from './components/BrowseJobs';
import Form from './components/Form';
import Categories from './components/Categories';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsConditions from './components/TermsConditions';
import Alerts from './components/Alerts';
import Companies from './components/Companies';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import CompanyJobs from './components/CompanyJobs';
import JobMeta from './components/JobMeta';
import LocationJobs from './components/LocationJobs';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

// Component to render both the meta tags and job detail
const JobWithMeta = () => {
  return (
    <>
      <JobMeta />
      <JobDetail source="jobCode" />
    </>
  );
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home/>} />
            {/* Job detail routes - order matters here */}
            <Route path="/jobs/:jobCode" element={<JobWithMeta />} />
            <Route path="/job-detail/:title/:id" element={<JobDetail/>} />
            <Route path="/jobs/:jobTitle" element={<JobDetail source="jobTitle"/>} />
            
            {/* Other routes */}
            <Route path="/category/:category" element={<CategoryJobs/>} />
            <Route path="/company/:company" element={<CompanyJobs/>} />
            <Route path="/location/:locationName" element={<LocationJobs/>} />
            <Route path="/categories" element={<Categories/>} />
            <Route path="/browse-jobs" element={<BrowseJobs/>} />
            <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
            <Route path="/terms-conditions" element={<TermsConditions/>} />
            <Route path="/job-alerts" element={<Alerts/>} />
            <Route path="/companies" element={<Companies/>} />
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </QueryClientProvider>
  );
}

export default App;
